import { CHAT_BOT_SHOW_AFTER_SPINNER } from './ChatbotAction';

const initialState = {
  chatBotShow: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CHAT_BOT_SHOW_AFTER_SPINNER:
      return {
        ...state,
        chatBotShow: action.payload.chatBotShow,
      };
    default:
      return state;
  }
};

export default reducer;
